import { EBenefitTypes } from "../enums/benefits.enums";
import { CompanyBenefitDto, Entitlement } from "../types/benefits.types";
import { computeEntitlement } from "./benefits.domain";

export const normalizeBenefits = (payload: CompanyBenefitDto[]) => {
    const now = new Date();
    const map: Partial<Record<EBenefitTypes, Entitlement>> = {};
    for (const dto of payload) {
        const ent = computeEntitlement(dto, now);
        map[ent.type] = ent;
    }
    return map;
};

export const recomputeUsage = (ent: Entitlement) => {
    ent.isExpired = ent.expDate ? new Date(ent.expDate).getTime() <= Date.now() : false;

    if (ent.isLimitedUsage && typeof ent.limit === "number") {
        ent.remaining = Math.max(0, ent.limit - ent.used);
        ent.canUseNow = !ent.isExpired && ent.used < ent.limit;
    } else {
        ent.remaining = undefined;
        ent.canUseNow = !ent.isExpired;
    }
};